window.NHS.Scripts.Favorites = function (parameters) {
  'use strict';

  const self = this;
  this.params = parameters;
  this.isMailFavoriteRun = true;
  this.setUpFullImageViewerSaveOption = function () {
    const template = document.querySelector('section.viewer');
    const mainSaveOption = document.querySelector('.nhs_favSaved');
    const fullImageViewerSaveOption = template.querySelectorAll("[data-component='full-image-viewer-favorites']");

    if (mainSaveOption && mainSaveOption.dataset.favid) {
      for (let index = 0; index < fullImageViewerSaveOption.length; index += 1) {
        fullImageViewerSaveOption[index].setAttribute('data-remove-local-storage', 'True');
        fullImageViewerSaveOption[index].firstElementChild.lastElementChild.style.display = 'block';
        fullImageViewerSaveOption[index].firstElementChild.firstElementChild.style.display = 'none';
        fullImageViewerSaveOption[index].dataset.favid = mainSaveOption.dataset.favid;
        fullImageViewerSaveOption[index].dataset.element = mainSaveOption.dataset.element;
        fullImageViewerSaveOption[index].classList.add('nhs_favSaved');
        fullImageViewerSaveOption[index].classList.remove('nhs_favUnsave');
        fullImageViewerSaveOption[index].querySelector('span').innerText =
          fullImageViewerSaveOption[index].dataset.savedText;
      }
    }

    self.init();
  };
};

window.NHS.Scripts.Favorites.prototype =
  {
    init() {
      'use strict';

      const self = this;
      const pendingItems = document.cookie.match(/pendingSaveItem=([^;]+)/);
      const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];
      const favoriteElements = document.querySelectorAll('.nhs_favLogin');
      const isLoggedIn = favoriteElements.length === 0;
      const pendingItemsFromMail = document.cookie.match(/TemporalFavoritesCookie_[0-9]=([^;]+)/);
      const mailFavorites = pendingItemsFromMail ? pendingItemsFromMail[1] : null;

      if (mailFavorites && self.isMailFavoriteRun && cookieFavorites.indexOf(JSON.parse(mailFavorites).id) === -1) {
        const topSaveElement = document.querySelector('[data-main-gallery-container] [data-favorite-trigger]');

        if (cookieFavorites.length > 0) {
          window.NHS.Scripts.Favorites.prototype.showLogInForSaveToFavorites(topSaveElement);
        } else {
          cookieFavorites.push(mailFavorites);
          const cookie = [
            'pendingSaveItem',
            '=',
            JSON.stringify(cookieFavorites),
            '; domain=.',
            window.location.host.toString(),
            '; path=/;'
          ].join('');
          document.cookie = cookie;
        }

        self.isMailFavoriteRun = false;
      }

      if (cookieFavorites) {
        for (let index = cookieFavorites.length - 1; index >= 0; index -= 1) {
          const favoriteString = cookieFavorites[index];
          const favoriteObject = JSON.parse(favoriteString);

          if (isLoggedIn) {
            const saveElements = document.querySelectorAll(`#${favoriteObject.element}`);

            saveElements.forEach((element) => {
              window.NHS.Scripts.Favorites.prototype.updateStylesToSaved(
                element.dataset.category,
                favoriteObject.id,
                0,
                element
              );

              if (element.matches('[data-full-image-viewer-save-button]')) {
                element.removeAttribute('data-event');
              }
            });

            let element = document.querySelector('#' + favoriteObject.element);
            if (!element) {
              element = {
                dataset: favoriteObject.dataset
              };
            }
            self.removeFromCookie(cookieFavorites, favoriteObject.id);
            self.saveToFavs(
              element,
              favoriteObject.category,
              favoriteObject.type,
              favoriteObject.id,
              favoriteObject.url,
              favoriteObject.name,
              self
            );
          }
        }
      }

      // On Click Save to Favorites
      const unSaveOptions = document.querySelectorAll('.nhs_favUnsave:not([data-favorite-unclick])');
      for (let i = 0; i < unSaveOptions.length; i += 1) {
        unSaveOptions[i].onclick = function () {
          self.saveElement(this, self);
        };
      }

      // On Click un Save to Favorites
      const saveOptions = document.querySelectorAll('.nhs_favSaved:not([data-favorite-unclick])');
      for (let i = 0; i < saveOptions.length; i += 1) {
        saveOptions[i].onclick = function () {
          self.unSaveElement(this, self);
        };
      }

      // On Click Save to Nearby Communities Favorites
      const nearByUnSaveOptions = document.querySelectorAll('.nhs_nbyFavUnsave');
      for (let i = 0; i < nearByUnSaveOptions.length; i += 1) {
        nearByUnSaveOptions[i].onclick = function () {
          self.saveElement(this, self);
        };
      }

      // On Click un Save to Nearby Communities Favorites
      const nearBySaveOptions = document.querySelectorAll('.nhs_nbyFavUnsaved');
      for (let i = 0; i < nearBySaveOptions.length; i += 1) {
        nearBySaveOptions[i].onclick = function () {
          self.unSaveElement(this, self);
        };
      }

      for (const favoriteElement of favoriteElements) {
        favoriteElement.removeEventListener('click', self.handleLoggedOutFavorites);
        favoriteElement.addEventListener('click', self.handleLoggedOutFavorites);
      }
    },

    /**
  * @private
  * showLogInForSaveToFavorites: propmts a modal asking the user to log in in order to save more favorites.
  *
  * @param {HTML} element with the url for login
  */
    showLogInForSaveToFavorites(element) {
      'use strict';

      if (element === null) {
        return;
      }
      const url = element.href || element.alt || element.dataset.modalUrl;
      window.NewHomeSource.ModalLoader.showModal(url);
    },

    handleLoggedOutFavorites(event) {
      'use strict';

      // Get the pendingSaveItem cookie to check for pending favorites to be saved.
      const pendingItems = document.cookie.match(/pendingSaveItem=([^;]+)/);
      const temporalSavedItems = pendingItems ? JSON.parse(pendingItems[1]) : [];

      event.preventDefault();
      event.stopPropagation();

      const wasPropertyUnsaved =
        window.NHS.Scripts.Favorites.prototype.removeFromCookie(temporalSavedItems, this.dataset.id);
      const saveButton = event.target.closest('[data-full-image-viewer-save-button]');

      if (wasPropertyUnsaved) {
        if (saveButton) {
          saveButton.setAttribute('data-event', 'true');
        }
        return;
      }

      if (saveButton) {
        saveButton.removeAttribute('data-event');
      }

      // add the new pending favorite to the list of pending items.
      temporalSavedItems.push(JSON.stringify({
        element: this.id,
        category: this.dataset.category,
        type: this.dataset.type,
        id: this.dataset.id,
        url: this.dataset.url,
        name: this.dataset.name,
        dataset: this.dataset
      }));

      // add the new pending favorite to the cookie.
      const cookie = [
        'pendingSaveItem',
        '=',
        JSON.stringify(temporalSavedItems),
        '; domain=.',
        window.location.host.toString(),
        '; path=/;'
      ].join('');

      document.cookie = cookie;

      // If the user is not logged in, show the login modal.
      if (window.auth0Dom) {
        window.auth0Dom.signIn({});
      }
    },

    removeFromCookie(items, id) {
      'use strict';

      const itemIndex = items.map((item) => JSON.parse(item).id).indexOf(id);

      if (itemIndex >= 0) {
        items.splice(itemIndex, 1);
        const cookie =
        ['pendingSaveItem',
          '=',
          JSON.stringify(items),
          '; domain=.',
          window.location.host.toString(),
          '; path=/;'
        ].join('');
        document.cookie = cookie;
      }

      return itemIndex >= 0;
    },
    // link is a dom element
    unSavedFavs(link, category, itemId, id) {
      'use strict';

      const self = this;

      if (link.classList.contains('nhs_favLogin')) {
        return;
      }

      const data = {
        Id: id
      };

      const xhr = new XMLHttpRequest();
      xhr.open('POST', self.params.urlBase + '/favorites/delete', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));

      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) {
          return;
        }

        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response);

          if (response.Saved) {
            document.body.dispatchEvent &&
            document.body.dispatchEvent(new CustomEvent('trackIdentifySaveItems', {
              detail: { data: link }
            }));

            self.updateStylesToUnsaved(category, itemId, link);
          }
        }
      };
    },
    // link is a dom element
    saveToFavs(link, category, type, id, url, name) {
      'use strict';

      const self = this;
      const itemId = id;

      self.logSegmentEvent((type === 'HomePlan' || type === 'HomeSpec')
        ? 'Home Favorited'
        : 'Community Favorited', type, id);

      if (self.params && typeof (self.params.logInfo) === 'undefined') {
        self.params.logInfo = { marketId: self.params.marketId, partnerId: self.params.partnerId };

        if (category === 'homeresults' && type === 'HomePlan') {
          self.params.logInfo.planId = id;
        } else if (category === 'homeresults' && type === 'HomeSpec') {
          self.params.logInfo.specificationId = id;
        } else {
          self.params.logInfo.communityId = id;
        }
      }

      self.logEvents(category, type, id, self);

      const data = {
        Type: type,
        Id: id,
        FavoriteUrl: url,
        Title: name
      };

      const xhr = new XMLHttpRequest();
      xhr.open('POST', self.params.urlBase + '/favorites/save', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));

      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) {
          return;
        }

        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response);

          if (response.Saved) {
            self.logSegmentEvent((type === 'HomePlan' || type === 'HomeSpec') ? 'Home Saved'
              : 'Community Saved', type, id);

            document.body.dispatchEvent &&
            document.body.dispatchEvent(new CustomEvent('trackIdentifySaveItems', {
              detail: { data: link }
            }));

            // send this event only to manufactured listings
            const isManufactured = link.parentElement.querySelector('[data-display-mf-events]');
            if (isManufactured) {
              const gaEvent = {
                event: 'GAEvent',
                eventType: 'GAEvent',
                eventCategory: 'TDV Event',
                eventAction: 'Listing Saved',
                eventLabel: 'homes-srp-mfgcard-fav',
              };
              document.body.dispatchEvent &&
                document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
                  detail: { data: gaEvent }
                }));
            }

            self.updateStylesToSaved(category, itemId, response, link);
          }
        }
      };
    },

    logEvents(category, type, id) {
      'use strict';

      const self = this;

      if (typeof self.params.logInfo === 'undefined') {
        return;
      }

      const log = logger || self.params.logInfo;

      if (category === 'commheader') {
        log.googlepush('Community Detail Events', 'Community - Gallery', 'Save to favorites');
      } else if (category === 'commfooter') {
        log.googlepush('Community Detail Events', 'Community - Next Steps', 'Save to favorites');
      } else if (category === 'mpcheader') {
        log.googlepush('Community Detail Events', 'Master Plan Community - Header', 'Save to favorites');
      } else if (category === 'mpcfooter') {
        log.googlepush('Community Detail Events', 'Master Plan Community - Next Steps', 'Save to favorites');
      } else if (category === 'homeheader') {
        log.googlepush('Home Detail Events', 'Home - Gallery', 'Save to favorites');
      } else if (category === 'homefooter') {
        log.googlepush('Home Detail Events', 'Home - Next Steps', 'Save to favorites');
      } else if (category === 'mainviewer') {
        log.googlepush('Gallery Detail Pages', 'Favorite', 'Favorite Heart Icon clicks');

        if (type === 'Community') {
          log.logEventWithParameters('CDSTC', self.params.logInfo);
        } else {
          log.logEventWithParameters('HOMSTC', self.params.logInfo);
        }
      } else if (category === 'homesgrid') {
        const homeLogInfo = Object.assign(self.params.logInfo);

        log.googlepush('Image Viewer', 'Image Viewer', 'Image Viewer - Homes Favorite');

        if (type === 'HomePlan') {
          homeLogInfo.planId = id;
        } else if (type === 'HomeSpec') {
          homeLogInfo.specId = id;
        }

        log.logEventWithParameters('HOMSTC', homeLogInfo);
      } else if (category === 'commresults') {
        log.googlepush('Community Results Events', 'Community Item', 'Save to favorites');
        log.googlepush('Search Events', 'Search Results', 'Favorite Community');
        log.SetDataLayerPair('favoriteSaved');
        log.logEventWithParameters('SAVETOFAV_CR', self.params.logInfo);
      } else if (category === 'homeresults') {
        log.googlepush('Community Results Events', 'Home Item', 'Save to favorites');
        log.logEventWithParameters('SAVETOFAV_HR', self.params.logInfo);
      } else if (category === 'builder') {
        log.googlepush('Builder Showcase Events', 'Builder Showcase', 'Save to favorites');
        log.logEventWithParameters('SAVETOFAV_BSC', self.params.logInfo);
      } else if (category === 'nbyCommheader') {
        log.googlepush('Community Detail Events', 'Community - Gallery', 'Save to favorites');
      }
    },

    logSegmentEvent(segmentEvent, type, id) {
      'use strict';

      const commonProperties = document.querySelector('#data-commonProperties_' + id);

      let eventForSegment = {
        event: segmentEvent,
        eventType: 'segmentEvent',
        home_id: type === 'HomePlan' ? id : null,
        spec_id: type === 'HomeSpec' ? id : null,
      };

      if (type === 'Community') {
        eventForSegment.community_id = id;
      }

      if (commonProperties && commonProperties.dataset) {
        eventForSegment = Object.assign(eventForSegment, commonProperties.dataset);
      }

      document.body.dispatchEvent && document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventForSegment }
      }));
    },

    saveElement: function saveElement(elementToSave) {
      'use strict';

      const self = this;

      self.saveToFavs(
        elementToSave,
        elementToSave.dataset.category,
        elementToSave.dataset.type,
        elementToSave.dataset.id,
        elementToSave.dataset.url,
        elementToSave.dataset.name,
        self
      );
    },

    unSaveElement(elementToUnsave) {
      'use strict';

      const self = this;
      const itemId = elementToUnsave.dataset.element.replace('nhs_SaveItem', '');
      const id = elementToUnsave.dataset.favid;

      self.unSavedFavs(
        elementToUnsave,
        elementToUnsave.dataset.category,
        itemId,
        id,
        self
      );
    },

    updateStylesToSaved(category, itemId, response, link) {
      'use strict';

      const self = this;
      if (category === '' ||
        category === 'mainviewer' ||
        category === 'homefooter' ||
        category === 'commheader' ||
        category === 'commfooter' ||
        category === 'commresults' ||
        category === 'homeresults' ||
        !link) {
        const savedElements =
          document.querySelectorAll(
            `.nhs_favSaved[data-element='nhs_SaveItem${itemId}']:not([data-component='full-image-viewer-favorites'])`
          );

        for (let i = 0; i < savedElements.length; i += 1) {
          savedElements[i].dataset.favid = response.Id;
          savedElements[i].style.display = 'block';
        }

        const unsaveElements =
          document.querySelectorAll(
            `.nhs_favUnsave[data-element='nhs_SavedItem${itemId}']:not([data-component='full-image-viewer-favorites']), [data-favorites-save]`
          );

        for (let i = 0; i < unsaveElements.length; i += 1) {
          unsaveElements[i].style.display = 'none';
        }

        if (category === 'mainviewer') {
          const heartElements = document.querySelectorAll("[data-component='full-image-viewer-favorites']");
          for (let index = 0; index < heartElements.length; index += 1) {
            heartElements[index].dataset.favid = response.Id;
            heartElements[index].setAttribute('data-remove-local-storage', 'True');
            heartElements[index].firstElementChild.firstElementChild.style.display = 'none';
            heartElements[index].firstElementChild.lastElementChild.style.display = 'block';
            heartElements[index].querySelector('span').innerText = heartElements[index].dataset.savedText;
            heartElements[index].classList.remove('nhs_favUnsave');
            heartElements[index].classList.add('nhs_favSaved');

            heartElements[index].onclick = function () {
              self.unSaveElement(heartElements[0], self);
            };
          }
        }
      } else if (category === 'nbyCommheader') {
        const savedItem = document.getElementById('nhs_SavedItem' + itemId);
        if (savedItem) {
          savedItem.style.display = 'block';
          savedItem.dataset.favid = response.Id;
        }

        const saveItem = document.getElementById('nhs_SaveItem' + itemId);
        if (saveItem) {
          saveItem.style.display = 'none';
        }
      } else if (link && link.parentElement) { // results pages
        const nextElement = link.parentElement.querySelector('[data-favorite-unsave]');

        if (nextElement) {
          nextElement.dataset.favid = response.Id;
          nextElement.style.display = 'block';
        }

        link.style.display = 'none';
      }
    },

    updateStylesToUnsaved(category, itemId, link) {
      'use strict';

      const self = this;
      if (category === '' ||
        category === 'mainviewer' ||
        category === 'commheader' ||
        category === 'commfooter' ||
        category === 'commresults' ||
        category === 'homeresults') {
        const savedElements =
          document.querySelectorAll(`.nhs_favSaved[data-element='nhs_SaveItem${itemId}']:not([data-component='full-image-viewer-favorites'])`);

        for (let i = 0; i < savedElements.length; i += 1) {
          delete savedElements[i].dataset.favid;
          savedElements[i].style.display = 'none';
        }

        const unsaveElements =
          document.querySelectorAll(`.nhs_favUnsave[data-element='nhs_SavedItem${itemId}']:not([data-component='full-image-viewer-favorites']), [data-favorites-save]`);

        for (let i = 0; i < unsaveElements.length; i += 1) {
          unsaveElements[i].style.display = 'block';
        }

        if (category === 'mainviewer') {
          const heartElements = document.querySelectorAll("[data-component='full-image-viewer-favorites']");
          for (let index = 0; index < heartElements.length; index += 1) {
            delete heartElements[index].dataset.favid;
            delete heartElements[index].dataset.removeLocalStorage;
            heartElements[index].firstElementChild.lastElementChild.style.display = 'none';
            heartElements[index].firstElementChild.firstElementChild.style.display = 'block';
            heartElements[index].querySelector('span').innerText = heartElements[index].dataset.saveText;
            heartElements[index].classList.add('nhs_favUnsave');
            heartElements[index].classList.remove('nhs_favSaved');

            heartElements[index].onclick = function () {
              self.saveElement(heartElements[0], self);
            };
          }
        }
      } else if (category === 'nbyCommheader') {
        const saveItem = document.getElementById('nhs_SaveItem' + itemId);
        if (saveItem) {
          saveItem.style.display = 'block';
          delete saveItem.dataset.favid;
        }

        const savedItem = document.getElementById('nhs_SavedItem' + itemId);
        if (savedItem) {
          savedItem.style.display = 'none';
        }
      } else if (link) {
        link.style.display = 'none';
        delete link.dataset.favid;
        link.previousElementSibling.style.display = 'block';
      }
    },

    cancelEventAndStopPropagation(event) {
      'use strict';

      const ev = event || window.event;
      ev.cancelBubble = true;
      ev.returnValue = false;

      if (ev.targetNode) {
        if (ev.stopPropagation) {
          ev.stopPropagation();
        }
      }

      if (ev.preventDefault) {
        ev.preventDefault();
      }
    },

    removeParam(parameter) {
      'use strict';

      let url = document.location.href;
      const urlparts = url.split('?');

      if (urlparts.length >= 2) {
        const urlBase = urlparts.shift();
        const queryString = urlparts.join('?');

        const prefix = encodeURIComponent(parameter) + '=';
        const pars = queryString.split(/[&;]/g);

        for (let i = pars.length; i-- > 0;) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            pars.splice(i, 1);
          }
        }

        url = urlBase + '?' + pars.join('&');
        window.history.pushState('', document.title, url);
      }
      return url;
    }
  };
